import React from "react";
import {
  Box,
  Heading,
  Table,
  Tbody,
  Tr,
  Td,
  Flex,
  Text,
  Spinner,
} from "@chakra-ui/react";
import { ArrowLeft, ChevronLeft } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { formatDate, formatDateTime, getFullName } from "../../../../utils/commonFunctions";

const CollectionDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { categoryData } = location.state || {};
  console.log("detail:", categoryData);
  const [isLoading, setIsLoading] = useState(true);
  const [lastImage, setLastImage] = useState("");

  useEffect(() => {
    // Simulate initial page load
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500); // Adjust time as needed

    return () => clearTimeout(timer);
  }, []);

  // Parse images and get the last one
  useEffect(() => {
    if (categoryData?.image) {
      try {
        let imagesArray = [];
        
        // Check if image is a string that looks like an array
        if (typeof categoryData.image === 'string') {
          // Remove brackets and split by comma
          const cleanString = categoryData.image.replace(/^\[|\]$/g, '');
          
          // Split by comma but be careful with commas inside URLs
          if (cleanString) {
            imagesArray = cleanString.split(',').map(url => url.trim());
            
            // Remove quotes if present
            imagesArray = imagesArray.map(url => url.replace(/^["']|["']$/g, ''));
          }
        } else if (Array.isArray(categoryData.image)) {
          imagesArray = categoryData.image;
        }
        
        // Get the last image
        if (imagesArray.length > 0) {
          setLastImage(imagesArray[imagesArray.length - 1]);
        }
      } catch (error) {
        console.error("Error parsing images:", error);
        setLastImage(categoryData.image); // Fallback to original string
      }
    }
  }, [categoryData]);

  return (
    <Box className="h-[93vh] flex flex-col">
      {isLoading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="#011638" />
        </div>
      )}

      <Box className="sticky top-0 z-10 bg-white ps-2 py-2 shadow-md">
        <span className="d-flex gap-2 justify-start items-center">
          <ChevronLeft
            onClick={() => navigate("/admin/inventory/collection")}
            className="hover:bg-gray-200 rounded-full"
            style={{ cursor: 'pointer' }}
          />
          <h4 className="mb-0">Category Detail</h4>
        </span>
      </Box>
      
      <Box className="flex-1 overflow-y-auto p-6">
        <Flex gap={6}>
          <Box
            flex="1"
            p={4}
            borderWidth="1px"
            borderRadius="lg"
            boxShadow="sm"
            bg="white"
            mt={6}
            gap={6}
          >
            <Heading as="h3" size="md" mb={4}>
              Category
            </Heading>
            <Table variant="simple" size="sm">
              <Tbody>
                <Tr>
                  <Td fontWeight="bold">Title</Td>
                  <Td>{categoryData?.name}</Td>
                </Tr>
                <Tr>
                  <Td fontWeight="bold">Parent Category</Td>
                  <Td>{categoryData?.parentCategoryName}</Td>
                </Tr>
                <Tr>
                  <Td fontWeight="bold">HSC Code</Td>
                  <Td>{categoryData?.hscCode || "N/A"}</Td>
                </Tr>
                <Tr>
                  <Td fontWeight="bold">Daily Production</Td>
                  <Td>{categoryData?.dailyProduction || "N/A"}</Td>
                </Tr>
                <Tr>
                  <Td fontWeight="bold">Tax</Td>
                  <Td>{categoryData?.tax ? `${categoryData.tax}%` : "N/A"}</Td>
                </Tr>
                <Tr>
                    <Td fontWeight="bold">Created By</Td>
                    <Td>{getFullName(categoryData.createdBy)}</Td>

                  </Tr>
                  <Tr>
                    <Td fontWeight="bold"> Modiefied By</Td>
                                        <Td>{getFullName(categoryData.modifiedBy)}</Td>

                  </Tr>
<Tr>
  <Td fontWeight="bold"> Created Time</Td>
<Td>{formatDateTime(categoryData.CREATEDTIME)}</Td>
</Tr>
<Tr>
  <Td fontWeight="bold"> Modiefied Time</Td>
  <Td>{formatDateTime(categoryData.MODIFIEDTIME)}</Td>

    
</Tr>
              </Tbody>
            </Table>
          </Box>
          
          <Box
            flex="1"
            p={4}
            borderWidth="1px"
            borderRadius="lg"
            boxShadow="sm"
            bg="white"
            mt={6}
          >
            <Heading as="h3" size="md" mb={4}>
              Image
            </Heading>
            {lastImage ? (
              <div>
                <img 
                  src={lastImage} 
                  alt="Category" 
                  style={{ 
                    width: "100%", 
                    maxHeight: "300px", 
                    objectFit: "cover",
                    borderRadius: "8px"
                  }} 
                />
               
              </div>
            ) : (
              <Text color="gray.500">No image available</Text>
            )}
          </Box>
        </Flex>
        
        <Box
          mt={6}
          p={4}
          borderWidth="1px"
          borderRadius="lg"
          boxShadow="sm"
          bg="white"
          w="100%"
        >
          <Heading as="h3" size="md" mb={4}>
            Description
          </Heading>
          <Text whiteSpace="pre-wrap">{categoryData?.description || "No description available"}</Text>
        </Box>
      </Box>
    </Box>
  );
};

export default CollectionDetail;